import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Badge from 'react-bootstrap/Badge';
import {BILLING_SUBSCRIPTION_COLLECTION_METHOD} from '../../../common/constants';
import {withTranslation} from 'react-i18next';
import {flowRight as compose} from 'lodash';

const BlueBtn = styled(Badge)`
  &&& {
    background-color: #1565c0;
    padding: 6px 14px;
    border: 0;
    cursor: default;
    color: white;
    font-size: 13px;
  }
`;

const OrangeBtn = styled(Badge)`
  &&& {
    background-color: #ff8a50;
    padding: 6px 14px;
    border: 0;
    cursor: default;
    color: white;
    font-size: 13px;
  }
`;

const GreyBtn = styled(Badge)`
  &&& {
    background-color: #9191b6;
    padding: 6px 14px;
    border: 0;
    cursor: default;
    color: white;
    font-size: 13px;
  }
`;

const DisplayCollectionMethod = ({t, collectionMethod}) => {
  if (collectionMethod === BILLING_SUBSCRIPTION_COLLECTION_METHOD.SEND_INVOICE) {
    return <BlueBtn>{t(collectionMethod)}</BlueBtn>;
  } else if (collectionMethod === BILLING_SUBSCRIPTION_COLLECTION_METHOD.CHARGE_AUTOMATICALLY) {
    return <OrangeBtn>{t(collectionMethod)}</OrangeBtn>;
  } else {
    return <GreyBtn>{t(collectionMethod)}</GreyBtn>;
  }
};

DisplayCollectionMethod.propTypes = {
  t: PropTypes.func.isRequired,
  collectionMethod: PropTypes.string.isRequired,
};

export default compose(
  withTranslation('billing'),
)(DisplayCollectionMethod);

